import React, { useState } from 'react';
import consulting from '../assets/img/consultant.png';
import chemicalPlants from '../assets/img/chemical-plant.png';
import petroleumRefineries from '../assets/img/oil-industry.png';
import industrialDetergents from '../assets/img/detergent.png';
import { motion } from 'framer-motion';
import '../App.css'



function Services({ t,language }) {
    const isMobile = window.innerWidth < 500;
    const isRTL = language === 'ar' || language === 'ku';

    return (
        <div className=' flex-row md:m-20 md:mt-10'>
            <div className=' md:ml-0 mt-5 mb-[-20px] md:mb-[-9px]'>
                <h1 className='text-xl text-center text-[#D2FF72] bg-[#16423ccc] rounded font-bold md:text-3xl  p-2  m-5 md:m-0 '> {t('serviceTitel')}</h1>
            </div>
            {/* {service.map((service, index) => ( */}

                <div
                    // key={index}
                    className={` text-${isRTL ? 'end' : 'start'} mt-[-3px] m-[50px] mx-auto md:m-2  relative  after:content after:absolute after:w-2 after:h-[100%] after:bg-[#16423ccc] after:top-0  after:left-[31px] md:after:left-[50%] after:ml-[-3px] after:z-10 after:animate-linear-6s  `}
                >

                    <div className=' p-[50px] md:pl-[60px] w-[100%] pl-[80px]  pr-[25px]  md:w-[50%] relative  left-0 '
                    >
                        <img src={consulting} alt='Consulting Engineer' className='w-10 rounded-full absolute  left-[10px] md:left-auto md:right-[-20px] top-16 z-20 bg-[#16423ccc]' />
                        <motion.div className='pl-5 pr-5 pt-12 pb-12 border-2 mr-5 shadow-lg rounded-md relative text-lg bg-[#c4dad28f]'
                            initial={{ opacity: 0, x: isMobile ? 100 : -300 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -300 }}
                            transition={{ duration: isMobile ? 1.5 : 2 }}
                            viewport={{ once: false, amount: 0.5 }}
                        >
                            <h2 className='text-[#16423c] md:text-2xl font-bold'>{t('service1')}</h2>
                            <p className='md:text-xl'>
                                {t('consultingDescripstion')}
                            </p>
                            <span className="h-0 w-0 absolute top-7 left-[-15px] md:left-auto md:right-[-15px] z-1 border-t-[15px] border-t-transparent border-b-[15px] border-b-transparent border-r-[15px] md:border-r-0 md:border-l-[15px] "></span>
                        </motion.div>
                    </div>

                    <div
                        className=' p-[50px] md:pl-[60px] w-[100%] pl-[80px]  pr-[25px]  md:w-[50%] relative left-0 md:left-[50%]'
                    >
                        <img src={chemicalPlants} alt='Chemical Plants' className='w-10 rounded-full absolute left-[10px] md:left-[-20px] top-16 z-20 bg-[#16423ccc]' />
                        <motion.div className='pl-5 pr-5 pt-12 pb-12 border-2 mr-5 shadow-lg rounded-md relative text-lg bg-[#c4dad28f]'
                            initial={{ opacity: 0, x: isMobile ? 100 : 300 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 300 }}
                            transition={{ duration: isMobile ? 1.5 : 2 }}
                            viewport={{ once: false, amount: 0.5 }}
                        >
                            <h2 className='text-[#16423c] md:text-2xl font-bold'>{t('service2')}</h2>
                            <p className='md:text-xl'>
                            {t('chemicalDescripstion')}
                            </p>
                            <span className="h-0 w-0 absolute top-7 left-[-15px] z-1 border-t-[15px] border-t-transparent border-b-[15px] border-b-transparent border-r-[15px] 0"></span>
                        </motion.div>
                    </div>

                    <div className='p-[50px] md:pl-[60px] w-[100%] pl-[80px]  pr-[25px]  md:w-[50%] relative left-0'

                    >
                        <img src={petroleumRefineries} alt='Petroleum Refineries' className='w-10 rounded-full absolute  left-[10px] md:left-auto  md:right-[-20px] top-16 z-20 bg-[#16423ccc]' />
                        <motion.div className='pl-5 pr-5 pt-12 pb-12 border-2 mr-5 shadow-lg rounded-md relative text-lg bg-[#c4dad28f]'
                            initial={{ opacity: 0, x: isMobile ? 100 : -300 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -300 }}
                            transition={{ duration: isMobile ? 1.5 : 2 }}
                            viewport={{ once: false, amount: 0.5 }}
                        >
                            <h2 className='text-[#16423c] md:text-2xl font-bold'>{t('service3')}</h2>
                            <p className='md:text-xl'>
                                {t('petroleumDescripstion')}
                            </p>
                            <span className="h-0 w-0 absolute top-7 left-[-15px] md:left-auto md:right-[-15px] z-1 border-t-[15px] border-t-transparent border-b-[15px] border-b-transparent border-r-[15px] md:border-r-0 md:border-l-[15px]"></span>
                        </motion.div>
                    </div>

                    <div
                        className='p-[50px] md:pl-[60px] w-[100%] pl-[80px]  pr-[25px]  md:w-[50%] relative left-0 md:left-[50%]'

                    >
                        <img src={industrialDetergents} alt='Industrial Detergents' className='w-10 rounded-full absolute left-[10px] md:left-[-20px] top-16 z-20 bg-[#16423ccc]' />
                        <motion.div className='pl-5 pr-5 pt-12 pb-12 border-2 mr-5 shadow-lg rounded-md relative text-lg bg-[#c4dad28f]'
                            initial={{ opacity: 0, x: isMobile ? 100 : 300 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 300 }}
                            transition={{ duration: isMobile ? 1.5 : 2 }}
                            viewport={{ once: false, amount: 0.5 }}
                        >
                            <h2 className='text-[#16423c] md:text-2xl font-bold'>{t('service4')}</h2>
                            <p className='md:text-xl'>
                                {t('industrialDescripstion') }
                            </p>
                            <span className="h-0 w-0 absolute top-7 left-[-15px] z-1 border-t-[15px] border-t-transparent border-b-[15px] border-b-transparent border-r-[15px] "></span>
                        </motion.div>

                    </div>

                </div>
        </div>
    );
}

export default Services;
